import { Result } from 'antd';
import React from 'react';
import './index.scss';
import { useLanguage } from 'hooks/Language/useLanguage';

const PageNotFound = () => {
  const { translate } = useLanguage();
  return (
    <div className="error-page">
      <Result
        status="404"
        title="404"
        style={{ marginTop: '10%' }}
        subTitle={translate(
          'Sorry, the page you visited does not exist.',
        )}
      />
    </div>
  );
};

export default PageNotFound;
